import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { PersonaEligibilityDocsComponent } from './persona-eligibility-docs/persona-eligibility-docs.component'
import { PersonaEligibilityExampleComponent } from './persona-eligibility-docs/persona-eligibility-example.component'
import { SharedUiPersonaEligibilityModule } from '../lib/shared-ui-persona-eligibility.module'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SharedUiPersonaEligibilityModule,
  ],
  declarations: [
    PersonaEligibilityDocsComponent,
    PersonaEligibilityExampleComponent,
  ],
  exports: [PersonaEligibilityDocsComponent],
})
export class SharedUiPersonaEligibilityDocsModule {}
